/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Leadspace type
 */
export var LEADSPACE_TYPE;
/**
 * Gradient style scheme.
 */

(function (LEADSPACE_TYPE) {
  LEADSPACE_TYPE["SMALL"] = "small";
  LEADSPACE_TYPE["LEFT"] = "left";
  LEADSPACE_TYPE["CENTERED"] = "centered";
})(LEADSPACE_TYPE || (LEADSPACE_TYPE = {}));

export var LEADSPACE_GRADIENT_STYLE_SCHEME;
/**
 * Leadspace size
 */

(function (LEADSPACE_GRADIENT_STYLE_SCHEME) {
  LEADSPACE_GRADIENT_STYLE_SCHEME["NONE"] = "";
  LEADSPACE_GRADIENT_STYLE_SCHEME["WITH_GRADIENT"] = "with-gradient";
})(LEADSPACE_GRADIENT_STYLE_SCHEME || (LEADSPACE_GRADIENT_STYLE_SCHEME = {}));

export var LEADSPACE_SIZE;

(function (LEADSPACE_SIZE) {
  LEADSPACE_SIZE["NONE"] = "";
  LEADSPACE_SIZE["TALL"] = "tall";
  LEADSPACE_SIZE["MEDIUM"] = "medium";
  LEADSPACE_SIZE["SUPER"] = "super";
})(LEADSPACE_SIZE || (LEADSPACE_SIZE = {}));